import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import SwitchMod from '../../../global/SwitchMod';
import { useDispatch } from 'react-redux';
import { bajaProveedorUsuarioAction } from "./../../../ducks/porveedorUsuarioDuck";

const columns = [
  { id: "usurio", minWidth: 150, align: "center", label: 'Usuario' },
  { id: "Correo", minWidth: 150, align: "center", label: 'Correo' },
  { id: "telefono", minWidth: 150, align: "center", label: 'Teléfono' },
  { id: "Estatus", minWidth: 150, align: "center", label: 'Estatus' },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

export default function TUsuarios({rows, onEditar = () =>{}}) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // const onEdit = (rowItem) =>{
  //   onEditar(rowItem)
  // }
  const onChangeSwitch = (SwitchValue, SwitchCheked) =>{
    const valEstatus = SwitchCheked ? 1 : 0;
    dispatch(bajaProveedorUsuarioAction(SwitchValue, valEstatus)).then((Response) =>{
    });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.Id}>
                      <TableCell align='center'>
                        {`${row.Informacion.Nombre} ${row.Informacion.ApellidoPaterno} ${row.Informacion.ApellidoMaterno}`}
                      </TableCell>
                      <TableCell align="center">{row.Email}</TableCell>
                      <TableCell align="center">{row.Informacion.Telefono}</TableCell>
                      <TableCell align="center">
                        <SwitchMod
                          Name={`${row.Id}-Switch-${index}`}
                          Id={row.Id}
                          Estatus={row.Informacion.Estatus}
                          onChangeSwitch={onChangeSwitch}
                        />
                      </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}